import { queryOptions } from '@tanstack/react-query'
import { apiFetch } from '#/api/client'

export type OrgSettings = {
  account_limit: number
}

export const orgSettingsQueryOptions = queryOptions({
  queryKey: ['org', 'settings'] as const,
  queryFn: ({ signal }) =>
    apiFetch<OrgSettings>({ path: '/org/settings', signal }),
  staleTime: 5 * 60 * 1000,
})
